// src/pages/History/20thCentury/RiseFascismNazism.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_Cold_War.png';

function HistoryPageRiseFascismNazism() {
  return (
    <TopicPage
      topicKey="Rise of Fascism and Nazism"
      title="History: Rise of Fascism and Nazism"
      backgroundImage={bg}
      startRoute="/History-Rise-Fascism-Nazism-Go"
      scrollLabels={[
        "Post-WWI Conditions",
        "Mussolini and Hitler",
        "Ideologies and Expansion",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageRiseFascismNazism;
